<div class="chat-container">
  <div
    class="messages"
    appAutoScroll
    (unreadCountChange)="_onUnreadCountChange($event)"
  >
    @if (_showWelcomeScreen() && _welcomeConfig()) {
      <app-chat-welcome-screen
        [config]="_welcomeConfig()"
        (suggestionSelected)="_onSuggestionSelected($event)"
      />
    } @else {
      @for (message of _messages(); track message.id; let isLast = $last) {
        <app-chat-message
          [message]="message"
          [showStatus]="
            isLast && message.role === 'assistant' && _shouldShowStatus()
          "
          [statusText]="_currentStatusText()"
          [formattedTimestamp]="_getFormattedTimestamp(message.id)"
          [streaming]="
            isLast && message.role === 'assistant' && _isLastMessageStreaming()
          "
          [superseded]="!isLast"
          [navigateSkipConfirm]="_skipNavConfirm()"
          [isAdmin]="_isAdmin()"
          (fileDownload)="_onFileDownload($event)"
          (traceOpen)="_onTraceOpen($event)"
          (questionAnswered)="_onQuestionAnswered($event)"
          (navigateDecided)="_onNavigateDecided($event)"
          (navigateSkipConfirmChange)="_skipNavConfirm.set($event)"
          (approvalConfirmed)="_onApprovalConfirmed($event)"
          (approvalCancelled)="_onApprovalCancelled()"
        />
      }

      @if (_chatStatus() === 'error') {
        <app-chat-message
          [message]="_errorMessage()"
          [formattedTimestamp]="_getFormattedTimestamp(_errorMessageId)"
          [isError]="true"
          [title]="_errorDetails() ?? ''"
          (retryRequested)="_onRetry()"
        />
      }

      @if (_unreadCount()) {
        <app-unread-indicator
          [count]="_unreadCount()"
          (scrollRequested)="_onScrollToBottom()"
        />
      }
    }
  </div>

  @if (_showCustomerMismatchWarning()) {
    <myre-banner
      [content]="chatWordings.customerMismatchWarning()"
      type="warn"
    />
  }

  @if (_showContextZone()) {
    <div class="context-zone">
      <i class="myre-icon-localisation"></i>
      @if (_parentContextCount()) {
        <myre-tag
          [text]="_parentContextBadge()"
          [iconClass]="
            _contextUnfolded() ? 'myre-icon-arrow_down' : 'myre-icon-arrow_up'
          "
          [type]="_contextTagType"
          [isClickable]="true"
          [tooltip]="{
            content: contextParents,
            templateData: _parentContextItems(),
          }"
          [attr.aria-label]="_contextToggleLabel()"
          [attr.aria-expanded]="_contextUnfolded()"
          (onClick)="_onToggleContext()"
        />
      }
      <ul class="context-chips" role="list">
        @for (item of _shownContextItems(); track item.key) {
          <li>
            <myre-tag
              [text]="_contextItemText(item)"
              [type]="_contextTagType"
              [isDeletable]="true"
              (onDelete)="_onRemoveContextItem(item.key)"
            />
          </li>
        }
      </ul>
      <button
        class="context-remove-button"
        type="button"
        [title]="chatWordings.removeAllContext()"
        [attr.aria-label]="chatWordings.removeAllContext()"
        (click)="_onRemoveContext()"
      >
        <i class="myre-icon-close"></i>
      </button>
    </div>

    <ng-template #contextParents let-items>
      @for (item of items; track item.key) {
        <div>{{ _contextItemText(item) }}</div>
      }
    </ng-template>
  }

  <app-chat-input
    [chatStatus]="_chatStatus()"
    [config]="_inputConfig()"
    [disabled]="_showCustomerMismatchWarning()"
    [agentItems]="_agentDropdownItems()"
    [selectedAgentName]="_selectedAgentNameForDropdown()"
    (messageSent)="_onMessageSent($event)"
    (stopRequested)="_onStopRequested()"
    (filesSelected)="_onFilesSelected($event)"
    (enabledToolsChange)="_onEnabledToolsChange($event)"
    (debugChange)="_onDebugChange($event)"
    (agentChange)="_setAgent($event)"
    (memoryRequested)="_onMemoryRequested()"
  />
</div>
